import { render, staticRenderFns } from "./A2.vue?vue&type=template&id=7298df2c&"
import script from "./A2.vue?vue&type=script&lang=ts&"
export * from "./A2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports